import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import WithAuth from "../../hoc/WithAuth";
import { useGetMFIDashboardValues } from "../../api/agronomy";
import StatCard from "../../components/cards/stat-card/StatCard";
import ContractsTable from "../../components/tables/ContractsTable";
import { useNavigate } from "react-router-dom";
import { Pie, Bar, Line, Doughnut } from "react-chartjs-2";
import { useContractList } from "../../api/contract";
import ContractDashboard from "../../components/ContractDashboard";
import LoadingScreen from "../../components/LoadingScreen";
import { useGetStatusCount } from "../../hooks/useGetStatusCount";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
);

const AmfiDashboard = () => {
  const [tableIndex, setTableIndex] = useState<number>(0);
  const { data: bankDashboardValues } = useGetMFIDashboardValues();
  const [searchText, setSearchText] = useState("");
    const { data: contracts, isLoading } = useContractList();
    const [filteredContracts, setFilteredContracts] = useState<any[]>([]);
    const [statuses, setStatuses] = useState<any>({
      Signed: 0,
      Unsigned: 0,
    });
    const [selectedFilterIndex, setSelectedFilterIndex] = useState(0);
    const filters = useGetStatusCount(statuses);
  
  const navigate = useNavigate();

    useEffect(() => {
      if (contracts && contracts.data && contracts.data.data) {
        const modifiedData = contracts.data.data.map((item: any) => ({
          ...item,
        }));
  
        const signed = modifiedData.filter(
          (item: any) => item.contractStatus === "SIGNED"
        ).length;
        const unsigned = modifiedData.length - signed;
  
        setStatuses({ Signed: signed, Unsigned: unsigned });
  
        let filteredData = modifiedData;
  
        if (selectedFilterIndex === 1) {
          filteredData = filteredData.filter(
            (item: any) => item.contractStatus === "SIGNED"
          );
        } else if (selectedFilterIndex === 2) {
          filteredData = filteredData.filter(
            (item: any) => item.contractStatus !== "SIGNED"
          );
        }
  
        if (searchText) {
          filteredData = filteredData.filter(
            (item: any) =>
              item.contractNumber?.toLowerCase().includes(searchText.toLowerCase()) ||
              item.offTaker?.toLowerCase().includes(searchText.toLowerCase()) ||
              item.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
              item.product?.toLowerCase().includes(searchText.toLowerCase()) ||
              item.contractStatus?.toLowerCase().includes(searchText.toLowerCase())
          );
        }
  
        setFilteredContracts(filteredData);
      }
    }, [searchText, contracts, selectedFilterIndex]);

  if (isLoading) return <LoadingScreen />;
  return (
    <div className="w-full">
      <div className="w-full flex flex-col gap-6">
        <div className="flex flex-col md:flex-row justify-between w-full gap-4">
  <div
    onClick={() => {
      setTableIndex(2);
      navigate("/contracts");
    }}
    style={{ cursor: "pointer" }}
    className="flex-1"
  >
    <StatCard
      title="Number of Contracts"
      value={bankDashboardValues?.data?.data?.NoOfContracts || 0}
      bgColor="#000"
      icon={
        <svg
          fill="#000000"
          width="64px"
          height="64px"
          viewBox="0 0 32 32"
          fillRule="evenodd"
          clipRule={"evenodd"}
          strokeLinejoin="round"
          strokeMiterlimit={2}
          version="1.1"
          xmlSpace="preserve"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          {/* SVG Paths */}
        </svg>
      }
    />
  </div>
  <div
    onClick={() => {
      setTableIndex(2);
      navigate("/customers");
    }}
    style={{ cursor: "pointer" }}
    className="flex-1"
  >
    <StatCard
      title="Number of Farmers"
      value={bankDashboardValues?.data?.data?.NoOfFarmers || 0}
      bgColor="#49B896"
      icon={
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* SVG Paths */}
        </svg>
      }
    />
  </div>
  <div
    onClick={() => {
      setTableIndex(2);
      navigate("/");
    }}
    style={{ cursor: "pointer" }}
    className="flex-1"
  >
    <StatCard
      title="No. of Processed Loans"
      value={bankDashboardValues?.data?.data?.LoanProcessed || 0}
      bgColor="#CE7270"
      icon={
        <svg
          width="30"
          height="31"
          viewBox="0 0 30 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* SVG Paths */}
        </svg>
      }
    />
  </div>
  <div
    onClick={() => setTableIndex(2)}
    style={{ cursor: "pointer" }}
    className="flex-1"
  >
    <StatCard
      title="No. of Pending Loans"
      value={bankDashboardValues?.data?.data?.PendingLoans || 0}
      bgColor="#000"
      icon={
        <svg
          width="64px"
          height="64px"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
        >
          {/* SVG Paths */}
        </svg>
      }
    />
  </div>
</div>
        <div
          style={{
            justifyContent: "space-between",
            borderRadius: 8.5,
            marginTop: 25,
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 22,
            backgroundColor: "white",
          }}
        >
          <ContractsTable
        searchText={searchText}
        setSearchText={setSearchText}
        filteredContracts={filteredContracts}
        isLoading={isLoading}
        selectedFilterIndex={selectedFilterIndex}
        setSelectedFilterIndex={setSelectedFilterIndex}
        filters={filters}
      />
          {/* <ContractDashboard contractData={filteredContracts} /> */}
        </div>
      </div>
    </div>
  );
};

export default WithAuth(AmfiDashboard);
